import { lazy } from "react";
import CreateDiscount from "../pages/discount/create.discount";
import Dashboard from "../pages/dashboard/dasboard";

import DiscountList from "../pages/discount/list.discount";
import AddEvents from "../pages/event/basicinformation.event";
import AddEventDetails from "../pages/event/eventdetails.event";
import Events from "../pages/event/events";
import Payouts from "../pages/payouts/payouts";
import WorkspacePayouts from "../pages/payouts/workspace-payouts";
import Registration from "../pages/registration/registration";
import RegistrationDetails from "../pages/registration/registrationdetails.registration";

import AddTicket from "../pages/ticket/add-ticket";
import TicketFormPage from "../pages/ticket/ticket-form-page";
import MyProfile from "../pages/settings/myprofile.setting";

import Workspace from "../pages/new-workspace/workspace";

import KycVerification from "../pages/kyc-verification/kyc-verification";
import CustomForm from "../pages/custom-form/forms/customForm";

import CorralPage from "../pages/corral/CorralPage";
import Review from "../pages/review/review";
import BibIndex from "../pages/bib/Index";
import ReviewAndPublish from "../pages/event/reviewandpublish.event";
import ChangeRequests from "../pages/change-requests/change-requests";
const EventRefunds = lazy(() => import("../pages/refunds/event-refunds"));

type RouteDef = {
  path: string;
  component: React.ComponentType<any>;
  title: string;
  draftCheck: boolean;
  access_name?: string;
};

export const ROUTES: Record<string, RouteDef> = {
  // ______________event_______________
  ADD_EVENT: {
    path: "/add-event",
    component: AddEvents,
    title: "Add Event",
    draftCheck: false,
  },
  ADD_EVENT_DETAILS: {
    path: "/add-event-details/:id",
    component: AddEventDetails,
    title: "Event Details",
    draftCheck: false,
  },

  ADD_EVENT_CUSTOM_FORM: {
    path: "/add-event-custom-form/:id",
    component: CustomForm,
    title: "Event Custom Form",
    draftCheck: false,
  },
  CUSTOM_FORM: {
    path: "/custom-form/:id",
    component: CustomForm,
    title: "Custom Form",
    draftCheck: false,
  },
  ADD_TICKET: {
    path: "/add-event-ticket/:id",
    component: AddTicket,
    title: "Add Ticket",
    draftCheck: false,
  },
  TICKET_FORM: {
    path: "/add-event-ticket-form/:id/:ticketId?",
    component: TicketFormPage,
    title: "Ticket Form",
    draftCheck: false,
  },
  REVIEW: {
    path: "/review/:id",
    component: Review,
    title: "Review",
    access_name: "review",
    draftCheck: false,
  },
  EDIT_EVENT: {
    path: "/edit-event/:id",
    component: AddEvents,
    title: "Edit Event",
    draftCheck: false,
  },
  LIST_EVENT: {
    path: "/",
    component: Events,
    title: "Events",
    draftCheck: false,
  },
  DASHBOARD: {
    path: "/dashboard/:id",
    access_name: "dashboard",
    component: Dashboard,
    title: "dashboard",
    draftCheck: true,
  },
  REVIEW_AND_PUBLISH: {
    path: "/review-and-publish/:id",
    component: ReviewAndPublish,
    title: "Review and Publish",
    draftCheck: false,
  },
  // _______________________registration___________________
  REGISTRATION: {
    path: "/registration/:id",
    component: Registration,
    title: "Registration",
    access_name: "registrations",
    draftCheck: true,
  },

  EVENT_REGISTRATION: {
    path: "/registration-details/:id",
    component: RegistrationDetails,
    title: "Event Registration",
    access_name: "registrations",
    draftCheck: true,
  },
  REFUNDS: {
    path: "/refunds/:id",
    component: EventRefunds,
    title: "Refunds",
    access_name: "refunds",
    draftCheck: true,
  },

  // _____________________________Discount__________________
  DISCOUNT: {
    path: "/discount/:id",
    component: DiscountList,
    title: "Discount",
    access_name: "discounts",
    draftCheck: true,
  },

  ADD_DISCOUNT: {
    path: "/create-discount/:id",
    component: CreateDiscount,
    title: "Create Discount",
    access_name: "discounts",
    draftCheck: true,
  },

  // _________________________________payouts__________________________________________
  PAYOUTS: {
    path: "/payouts/:id",
    component: Payouts,
    title: "Payouts",
    access_name: "payouts",
    draftCheck: true,
  },
  WORKSPACE_PAYOUTS: {
    path: "/workspace-payouts",
    component: WorkspacePayouts,
    title: "Payout Report",
    draftCheck: false,
  },

  //________________________________________________________settings__________________________
  MY_PROFILE: {
    path: "/my-profile",
    component: MyProfile,
    title: "My Profile",
    draftCheck: false,
  },
  WORKSPACE_SETTING: {
    path: "/workspace",
    component: Workspace,
    title: "Workspace",
    draftCheck: false,
  },

  // __________________Permission____________
  REGISTRATIONS: {
    path: "/registration/:id",
    component: Registration,
    title: "Registration",
    access_name: "registrations",
    draftCheck: true,
  },
  DISCOUNTS: {
    path: "/discount/:id",
    component: DiscountList,
    title: "Discount",
    access_name: "discounts",
    draftCheck: true,
  },

  //_______________________________________________kyc-verification________________________________
  KYC_VERIFICATION: {
    path: "/kyc-verification",
    component: KycVerification,
    title: "KYC Verification",
    draftCheck: false,
  },

  // _____________________________________bib-corral_____________________
  BIB_ASSIGNMENT: {
    path: "/bib-assignment/:id",
    component: BibIndex,
    title: "BIB Assignment",
    access_name: "bib",
    draftCheck: true,
  },
  CORRAL_ALLOCATION: {
    path: "/corral-allocation/:id",
    component: CorralPage,
    title: "Corral Allocation",
    access_name: "corral",
    draftCheck: true,
  },

  // _____________________________________change-requests_____________________
  CHANGE_REQUESTS: {
    path: "/change-requests/:id",
    component: ChangeRequests,
    title: "Change Requests",
    access_name: "dashboard",
    draftCheck: true,
  },
};
